"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountLine = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
const DiscountLine = (props) => {
    function handleDiscountTitleChange(value) {
        const discountClone = (0, cloneDeep_1.default)(props.discount);
        discountClone.title = value.slice(0, 50);
        props.onDiscountChange(discountClone);
    }
    function handleDiscountValueChange(value) {
        const discountClone = (0, cloneDeep_1.default)(props.discount);
        let validValue = value ? Math.max(0, value) : 0;
        validValue = Math.round(validValue * 100) / 100;
        if (discountClone.percent !== undefined) {
            discountClone.percent = Math.min(validValue, 100);
        }
        else {
            discountClone.amount = Math.min(validValue, 1000000);
        }
        props.onDiscountChange(discountClone);
    }
    function handleDiscountTypeChange(type) {
        const discountClone = (0, cloneDeep_1.default)(props.discount);
        if (type === "%") {
            discountClone.percent = discountClone.amount;
            discountClone.amount = undefined;
        }
        else {
            discountClone.amount = discountClone.percent;
            discountClone.percent = undefined;
        }
        props.onDiscountChange(discountClone);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { className: "discount-title", type: "text", placeholder: "Beschreibung Rabatt", value: props.discount.title, onChange: (e) => handleDiscountTitleChange(e.target.value), disabled: !props.editable }),
        react_1.default.createElement(react_number_format_1.NumericFormat, { className: "discount-value", displayType: "input", thousandSeparator: "'", decimalSeparator: ".", placeholder: "Rabatt", decimalScale: 2, fixedDecimalScale: false, onFocus: (e) => e.target.select(), value: props.discount.getValue(), onValueChange: (e) => { var _a; return handleDiscountValueChange((_a = e.floatValue) !== null && _a !== void 0 ? _a : 0); }, disabled: !props.editable }),
        react_1.default.createElement("select", { className: "discount-type", value: props.discount.isPercent() ? "%" : "CHF", onChange: (e) => handleDiscountTypeChange(e.target.value), disabled: !props.editable },
            react_1.default.createElement("option", null, "%"),
            react_1.default.createElement("option", null, "CHF"))));
};
exports.DiscountLine = DiscountLine;
